import React from "react";

const LoadingButton = ({ height = "22px", width = "22px" }) => {
  return (
    <div
      class="spinner-border"
      style={{ height: { height }, width: { width } }}
      role="status"
    ></div>
  );
};

export default LoadingButton;
